/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandStatus} from '../api'

export const useMutationSetBrandStatus = createReactQueryMutationHook('setBrandStatus', setBrandStatus)
